
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/alloydb",
      function () {
        return require("private-next-pages/destinations/alloydb.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/alloydb"])
      });
    }
  